import React, { useEffect, useRef, useState } from "react";

import tamaraIcon from "../assets/images/Tamara1.png";
import madaIcon from "../assets/images/mada.png";
import mastercardIcon from "../assets/images/mastercard.png";
import payIcon from "../assets/images/pay.png";
import visaIcon from "../assets/images/visa.png";
import footer_logo from "../assets/images/footer_logo_white.png";

/**
 * Props:
 *   mode: "sticky" | "fixed"
 *   - "sticky" (default): footer peeks and is revealed as the page scrolls (no overlay)
 *   - "fixed": footer overlays the page; auto-opens on scroll and can be dragged
 */
export default function MobileFooterSheet({ mode = "sticky" }) {
  const [open, setOpen] = useState(false);

  // Only used in "fixed" mode for drag
  const startY = useRef(null);

  const onTouchStart = (e) => {
    if (mode !== "fixed") return;
    startY.current = e.touches[0].clientY;
  };
  const onTouchMove = (e) => {
    if (mode !== "fixed") return;
    if (startY.current == null) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy < -24) setOpen(true);   // drag up to open
    if (dy > 24) setOpen(false);  // drag down to close
  };
  const onTouchEnd = () => (startY.current = null);

  // Auto open on a tiny scroll (fixed mode only)
  useEffect(() => {
    if (mode !== "fixed") return;
    const onScroll = () => setOpen((window.scrollY || 0) > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [mode]);

  const cls =
    "m-sheet " +
    (mode === "sticky" ? "reveal-sheet" : "fixed-sheet") +
    (open ? " open" : "");

  const touchHandlers =
    mode === "fixed"
      ? { onTouchStart, onTouchMove, onTouchEnd }
      : {};

  return (
    <div className={cls} {...touchHandlers}>
      <div className="m-sheet-inner" dir="rtl">
        <div className="m-sheet-grid">
          <div className="search-item">
            <label>احفظها | PARTECH</label>
            <p>
              شركة سعودية موثوقة توفر جميع أنواع قطع غيار السيارات اليابانية،
              الأمريكية، الأوروبية والصينية، بجودة عالية لتصل إليك بسهولة.
            </p>
          </div>

          <div className="search-item">
            <label>طرق الدفع الإلكترونية</label>
            <div className="m-pay-logos">
              <img src={tamaraIcon} alt="تمارا" />
              <img src={madaIcon} alt="مدى" />
              <img src={mastercardIcon} alt="ماستر" />
              <img src={visaIcon} alt="فيزا" />
              <img src={payIcon} alt="Apple Pay" />
            </div>
          </div>
        </div>

        {/* new bottom row */}
        <div className="m-sheet-bottom">
          شركة احفظها ش.م.م - سجل تجاري رقم: 1009069725
        </div>
        <div className="m-sheet-bottom d-flex flex-wrap justify-content-between align-items-center">
          <p className="mb-0"><img src={footer_logo} width={30} alt="footer logo" style={{ marginLeft: "10px", borderRadius:"5px" }} />موثق لدى المركز السعودي للأعمال رقم التوثيق : 0000204712</p>
        </div>
      </div>
    </div>
  );
}